import React from 'react';
import { Box, Typography } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

export function Reports() {
  const { language } = useLanguage();

  const text = {
    fr: {
      title: 'Rapports',
      subtitle: 'Analysez vos performances',
    },
    en: {
      title: 'Reports',
      subtitle: 'Analyze your performance',
    }
  };

  const currentText = text[language as keyof typeof text];

  return (
    <Box sx={{ p: 3, bgcolor: '#f5f5f5', minHeight: '100vh' }}>
      <Typography variant="h4" gutterBottom>
        {currentText.title}
      </Typography>
      <Typography color="text.secondary">
        {currentText.subtitle}
      </Typography>
    </Box>
  );
}
